<template>
  <div v-if="meta">
    <div class="text-center">
      <span class="container">
        <div
          class="d-flex"
          style="justify-content: space-between"
        >
          <el-card
            class="mr-4"
            :body-style="{ height: '100%' }"
            style="flex: 1"
          >
            <div
              class="h-100 w-100 d-flex flex-column justify-content-between align-items-center"
            >
              <h5>{{ $t("budget_delivred") }}</h5>
              <div>
                <div :class="colorCampaignStatus">
                  <h1 class="mt-3">
                    {{ deliveredBudgetStats.percentageOfDeliveredBudget }}
                  </h1>
                  <h4>
                    {{
                      $t("deliveredBudget", {
                        value: currencyFormat(
                          deliveredBudgetStats.deliveredBudget
                        ),
                      })
                    }}
                  </h4>
                </div>
                <p>
                  <strong>
                    {{ $t("correspondTo") }}
                    <br />
                    {{
                      $t("numberOfWrittenWordsAndDeliveredContents", {
                        numberOfWrittenWords:
                          deliveredBudgetStats.numberOfWrittenWords,
                        numberOfDeliveredContents:
                          deliveredBudgetStats.numberOfDeliveredContents,
                      })
                    }}
                  </strong>
                </p>
                <p v-if="deliveredBudgetStats.numberOfTextsToPublish">
                  <i class="fas fa-exclamation-circle text-warning" />
                  <small
                    >{{ $t("youStillHave") }}
                    <el-button
                      @click="
                        changeFilter(
                          deliveredBudgetStats.numberOfTextsToPublish.action
                        )
                      "
                      type="text"
                      size="small"
                      >{{ deliveredBudgetStats.numberOfTextsToPublish.value }}
                      {{ $t("textToPublish") }}
                    </el-button>
                    {{ $t("inYourWebsite") }}
                  </small>
                </p>
              </div>
              <div />
            </div>
          </el-card>
          <el-card
            class="mr-4"
            :body-style="{ height: '100%' }"
            style="flex: 2"
          >
            <h5 class="px-3 mb-3">{{ $t("budget_in_process") }}</h5>
            <div
              class="d-flex"
              style="justify-content: space-between"
            >
              <div
                :body-style="{ height: '100%' }"
                style="flex: 1"
              >
                <div class="h-100 w-100 d-flex flex-column align-items-center">
                  <div>
                    <h5>
                      {{ $t("at") }} <b>{{ study.companyName }}</b>
                    </h5>
                    <h2>
                      {{
                        clientPendingBudgetStats.clientPendingBudgetPercentage
                      }}
                    </h2>
                    <p>
                      {{
                        $t("totalClientBudget", {
                          clientPendingBudget: currencyFormat(
                            clientPendingBudgetStats.clientPendingBudget
                          ),
                        })
                      }}
                    </p>
                  </div>
                  <p
                    v-if="
                      clientPendingBudgetStats.numberOfBriefsWaitingForValidation ||
                      clientPendingBudgetStats.numberOfTextsWaitingForValidation
                    "
                  >
                    <strong>{{ $t("correspondTo") }}</strong>
                  </p>
                  <ul class="text-left mb-0">
                    <li
                      @click="
                        changeFilter(
                          clientPendingBudgetStats
                            .numberOfBriefsWaitingForValidation.action
                        )
                      "
                      v-if="
                        clientPendingBudgetStats.numberOfBriefsWaitingForValidation
                      "
                    >
                      <el-button
                        size="small"
                        type="text"
                      >
                        {{
                          clientPendingBudgetStats
                            .numberOfBriefsWaitingForValidation.value
                        }}
                        {{ $t("briefsToValidate") }}</el-button
                      >
                    </li>
                    <li
                      @click="
                        changeFilter(
                          clientPendingBudgetStats
                            .numberOfTextsWaitingForValidation.action
                        )
                      "
                      v-if="
                        clientPendingBudgetStats.numberOfTextsWaitingForValidation
                      "
                    >
                      <el-button
                        size="small"
                        type="text"
                      >
                        {{
                          clientPendingBudgetStats
                            .numberOfTextsWaitingForValidation.value
                        }}
                        {{ $t("textsToValidate") }}</el-button
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div
                :body-style="{ height: '100%' }"
                style="flex: 1"
              >
                <div class="h-100 w-100 d-flex flex-column align-items-center">
                  <div>
                    <h5>{{ $t("at") }} <b>Smartkeyword</b></h5>
                    <h2>
                      {{
                        smartkeywordPendingBudgetStats.smartkeywordPendingBudgetPercentage
                      }}
                    </h2>
                    <p>
                      {{
                        $t("smartkeywordBudgetStats", {
                          smartkeywordPendingBudget: currencyFormat(
                            smartkeywordPendingBudgetStats.smartkeywordPendingBudget
                          ),
                        })
                      }}
                    </p>
                  </div>
                  <p
                    v-if="
                      smartkeywordPendingBudgetStats.numberOfBriefsToWrite ||
                      smartkeywordPendingBudgetStats.numberOfTextsToReview ||
                      smartkeywordPendingBudgetStats.numberOfBriefsToReview ||
                      smartkeywordPendingBudgetStats.numberOfTextsToModify ||
                      smartkeywordPendingBudgetStats.numberOfTextsToWrite ||
                      smartkeywordPendingBudgetStats.numberOfTextsInWriting ||
                      smartkeywordPendingBudgetStats.numberOfTextsBeingModified
                    "
                  >
                    <strong>{{ $t("correspondTo") }}</strong>
                  </p>
                  <ul class="text-left mb-0">
                    <li
                      v-if="
                        smartkeywordPendingBudgetStats.numberOfBriefsToWrite
                      "
                    >
                      <el-button
                        size="small"
                        type="text"
                        @click="
                          changeFilter(
                            smartkeywordPendingBudgetStats.numberOfBriefsToWrite
                              .action
                          )
                        "
                      >
                        {{
                          smartkeywordPendingBudgetStats.numberOfBriefsToWrite
                            .value
                        }}
                        {{ $t("briefsToWrite") }}</el-button
                      >
                    </li>
                    <li
                      v-if="
                        smartkeywordPendingBudgetStats.numberOfBriefsToReview
                      "
                    >
                      <el-button
                        size="small"
                        type="text"
                        @click="
                          changeFilter(
                            smartkeywordPendingBudgetStats
                              .numberOfBriefsToReview.action
                          )
                        "
                      >
                        {{
                          smartkeywordPendingBudgetStats.numberOfBriefsToReview
                            .value
                        }}
                        {{ $t("briefsToReadOver") }}</el-button
                      >
                    </li>
                    <li
                      v-if="smartkeywordPendingBudgetStats.numberOfTextsToWrite"
                    >
                      <el-button
                        size="small"
                        type="text"
                        @click="
                          changeFilter(
                            smartkeywordPendingBudgetStats.numberOfTextsToWrite
                              .action
                          )
                        "
                      >
                        {{
                          smartkeywordPendingBudgetStats.numberOfTextsToWrite
                            .value
                        }}
                        {{ $t("textsToWrite") }}</el-button
                      >
                    </li>
                    <li
                      v-if="
                        smartkeywordPendingBudgetStats.numberOfTextsInWriting
                      "
                    >
                      <el-button
                        size="small"
                        type="text"
                        @click="
                          changeFilter(
                            smartkeywordPendingBudgetStats
                              .numberOfTextsInWriting.action
                          )
                        "
                      >
                        {{
                          smartkeywordPendingBudgetStats.numberOfTextsInWriting
                            .value
                        }}
                        {{ $t("textsInWriting") }}</el-button
                      >
                    </li>
                    <li
                      v-if="
                        smartkeywordPendingBudgetStats.numberOfTextsToReview
                      "
                    >
                      <el-button
                        size="small"
                        type="text"
                        @click="
                          changeFilter(
                            smartkeywordPendingBudgetStats.numberOfTextsToReview
                              .action
                          )
                        "
                      >
                        {{
                          smartkeywordPendingBudgetStats.numberOfTextsToReview
                            .value
                        }}
                        {{ $t("textsToReview") }}</el-button
                      >
                    </li>
                    <li
                      v-if="
                        smartkeywordPendingBudgetStats.numberOfTextsBeingModified
                      "
                    >
                      <el-button
                        size="small"
                        type="text"
                        @click="
                          changeFilter(
                            smartkeywordPendingBudgetStats
                              .numberOfTextsBeingModified.action
                          )
                        "
                      >
                        {{
                          smartkeywordPendingBudgetStats
                            .numberOfTextsBeingModified.value
                        }}
                        {{ $t("textsBeingModified") }}</el-button
                      >
                    </li>
                    <li
                      v-if="
                        smartkeywordPendingBudgetStats.numberOfTextsToModify
                      "
                    >
                      <el-button
                        size="small"
                        type="text"
                        @click="
                          changeFilter(
                            smartkeywordPendingBudgetStats.numberOfTextsToModify
                              .action
                          )
                        "
                      >
                        {{
                          smartkeywordPendingBudgetStats.numberOfTextsToModify
                            .value
                        }}
                        {{ $t("textsToModify") }}</el-button
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-card>
          <el-card
            :body-style="{ height: '100%' }"
            style="flex: 1"
          >
            <div
              class="h-100 w-100 d-flex justify-content-between flex-column align-items-center"
            >
              <h5>{{ $t("budget_remaining") }}</h5>
              <div>
                <h1 class="mt-3">
                  {{ remaingingBudgetStats.percentageOfRemaingingBudget }}
                </h1>
                <h4>
                  {{
                    $t("remaingingBudgetStatsRemainingBudget", {
                      remainingBudget: currencyFormat(
                        remaingingBudgetStats.remainingBudget
                      ),
                    })
                  }}
                </h4>
                <!-- Trick to align both stats -->
                <div style="visibility: hidden">
                  <p>
                    <strong>
                      {{ $t("correspondTo") }}
                      <br />
                      {{
                        $t("numberOfWrittenWordsAndDeliveredContents", {
                          numberOfWrittenWords:
                            deliveredBudgetStats.numberOfWrittenWords,
                          numberOfDeliveredContents:
                            deliveredBudgetStats.numberOfDeliveredContents,
                        })
                      }}
                    </strong>
                  </p>
                  <p v-if="deliveredBudgetStats.numberOfTextsToPublish">
                    <i class="fas fa-exclamation-circle text-warning" />
                    <small
                      >{{ $t("youStillHave") }}
                      <el-button
                        @click="
                          changeFilter(
                            deliveredBudgetStats.numberOfTextsToPublish.action
                          )
                        "
                        type="text"
                        size="small"
                        >{{ deliveredBudgetStats.numberOfTextsToPublish.value }}
                        {{ $t("textToPublish") }}
                      </el-button>
                      {{ $t("inYourWebsite") }}
                    </small>
                  </p>
                </div>
                <!-- End of trick -->
              </div>
              <div />
            </div>
          </el-card>
        </div>
      </span>
    </div>
    <div>
      <!--not finished -->
      <div class="container">
        <div class="row">
          <div class="col-2">
            <h5>{{ $t("projectStatus") }}</h5>
          </div>
          <div class="col-10">
            <h4 :class="colorCampaignStatus">{{ contentCampaignStatus }}</h4>
          </div>
        </div>
        <div
          class="row"
          v-if="!campaign.isTerminated"
        >
          <div class="col-2">
            <h5>{{ $t("explanations") }}</h5>
          </div>
          <div class="col-10">
            <p v-if="isOnTrack">
              {{
                $t("onTrackExplications", {
                  theoreticalAdvancement: theoreticalAdvancement,
                })
              }}
            </p>
            <p v-else>
              <b
                >{{
                  $t("onDelayExplicationsFirstPart", {
                    percentageOfDelay: percentageOfDelay,
                  })
                }}
              </b>
              {{
                $t("onDelayExplications", {
                  theoreticalAdvancement: theoreticalAdvancement,
                  theoreticalBudgetToSpend: currencyFormat(
                    theoreticalBudgetToSpend
                  ),
                })
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    meta: Object,
    campaign: Object,
  },
  methods: {
    formatNumber(number) {
      return Math.floor(number)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
    percentageBuilder(value) {
      return Math.round(value * 100) / 100;
    },
    changeFilter(action) {
      this.$emit("change-filter-value", action);
    },
    currencyFormat(value) {
      return this.$options.filters.formatCurrency(value, this.$i18n.locale);
    },
  },
  computed: {
    ...mapState(["study"]),
    totalBudget() {
      return this.meta.totalBudget;
    },
    contentCampaignStatus() {
      if (this.campaign.isTerminated) return this.$t("terminated");
      return this.$t(this.meta.contentCampaignStatus.toLowerCase());
    },
    theoreticalAdvancement() {
      return this.percentageBuilder(this.meta.theoreticalAdvancement) + "%";
    },
    percentageOfDelay() {
      return this.percentageBuilder(this.meta.percentageOfDelay) + "%";
    },
    theoreticalBudgetToSpend() {
      return this.meta.theoreticalBudgetToSpend;
    },
    deliveredBudgetStats() {
      const object = this.meta.deliveredBudgetStats;

      let computedObject = {
        percentageOfDeliveredBudget:
          this.percentageBuilder(object.percentageOfDeliveredBudget) + "%",
        numberOfDeliveredContents: this.formatNumber(
          object.numberOfDeliveredContents
        ),
        numberOfWrittenWords: this.formatNumber(object.numberOfWrittenWords),
        deliveredBudget: object.deliveredBudget,
      };
      if (object.numberOfTextsToPublish) {
        computedObject.numberOfTextsToPublish = {
          action: object.numberOfTextsToPublish.action,
          value: this.formatNumber(object.numberOfTextsToPublish.value),
        };
      }
      return computedObject;
    },
    smartkeywordPendingBudgetStats() {
      const object = this.meta.smartkeywordPendingBudgetStats;
      let computedObject = {
        smartkeywordPendingBudget: object.smartkeywordPendingBudget,
        smartkeywordPendingBudgetPercentage:
          this.percentageBuilder(object.smartkeywordPendingBudgetPercentage) +
          "%",
      };
      if (object.numberOfBriefsToReview) {
        computedObject.numberOfBriefsToReview = {
          action: object.numberOfBriefsToReview.action,
          value: this.formatNumber(object.numberOfBriefsToReview.value),
        };
      }

      if (object.numberOfTextsToReview) {
        computedObject.numberOfTextsToReview = {
          action: object.numberOfTextsToReview.action,
          value: this.formatNumber(object.numberOfTextsToReview.value),
        };
      }

      if (object.numberOfTextsToWrite) {
        computedObject.numberOfTextsToWrite = {
          action: object.numberOfTextsToWrite.action,
          value: this.formatNumber(object.numberOfTextsToWrite.value),
        };
      }

      if (object.numberOfBriefsToWrite) {
        computedObject.numberOfBriefsToWrite = {
          action: object.numberOfBriefsToWrite.action,
          value: this.formatNumber(object.numberOfBriefsToWrite.value),
        };
      }

      if (object.numberOfTextsToModify) {
        computedObject.numberOfTextsToModify = {
          action: object.numberOfTextsToModify.action,
          value: this.formatNumber(object.numberOfTextsToModify.value),
        };
      }

      if (object.numberOfTextsBeingModified)
        computedObject.numberOfTextsBeingModified = {
          value: this.formatNumber(object.numberOfTextsBeingModified.value),
          action: object.numberOfTextsBeingModified.action,
        };

      if (object.numberOfTextsInWriting) {
        computedObject.numberOfTextsInWriting = {
          action: object.numberOfTextsInWriting.action,
          value: this.formatNumber(object.numberOfTextsInWriting.value),
        };
      }

      return computedObject;
    },
    clientPendingBudgetStats() {
      const object = this.meta.clientPendingBudgetStats;
      let computedObject = {
        clientPendingBudgetPercentage:
          this.percentageBuilder(object.clientPendingBudgetPercentage) + "%",
        clientPendingBudget: object.clientPendingBudget,
      };
      if (object.numberOfBriefsWaitingForValidation)
        computedObject.numberOfBriefsWaitingForValidation = {
          value: this.formatNumber(
            object.numberOfBriefsWaitingForValidation.value
          ),
          action: object.numberOfBriefsWaitingForValidation.action,
        };
      if (object.numberOfTextsWaitingForValidation)
        computedObject.numberOfTextsWaitingForValidation = {
          value: this.formatNumber(
            object.numberOfTextsWaitingForValidation.value
          ),
          action: object.numberOfTextsWaitingForValidation.action,
        };

      return computedObject;
    },
    remaingingBudgetStats() {
      const object = this.meta.remaingingBudgetStats;
      return {
        percentageOfRemaingingBudget:
          this.percentageBuilder(object.percentageOfRemaingingBudget) + "%",
        remainingBudget: object.remaingingBudget,
      };
    },
    colorCampaignStatus() {
      if (this.campaign.isTerminated) return;
      if (this.isOnTrack) return "text-success";
      else return "text-warning";
    },
    isOnTrack() {
      if (
        this.meta &&
        this.meta.contentCampaignStatus &&
        this.meta.contentCampaignStatus == "ON_TRACK"
      )
        return true;
    },
  },
};
</script>

<style scoped>
.financial-info-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  text-align: center;
}
h6 {
  font-weight: bold;
}
h4 {
  font-weight: bold;
}
</style>
<i18n>
{
  "en": {
    "deliveredBudget": "{value} of the total budget",
    "totalClientBudget": "{clientPendingBudget} of the total budget",
    "numberOfWrittenWordsAndDeliveredContents": "{numberOfWrittenWords} written words ({numberOfDeliveredContents} contents)",
    "smartkeywordBudgetStats": "{smartkeywordPendingBudget} of the total budget",
    "remaingingBudgetStatsRemainingBudget": "{remainingBudget} of the total budget",
    "textToPublish": "texts to be published",
    "inYourWebsite": "on your website",
    "at": "at",
    "correspondTo": "Correspond to:",
    "briefsToValidate": "brief(s) to approve",
    "textsToValidate": "text(s) to approve",
    "briefsToWrite": "brief(s) to write",
    "textsToWrite": "text(s) to write",
    "textsToReview": "text(s) to review",
    "textsInWriting": "text(s) in writing",
    "briefsToReadOver": "briefs(s) to read over",
    "textsBeingModified": "text(s) being modified",
    "textsToModify": "text(s) to modify",
    "atSmartkeyword": "AT SMARTKEYWORD",
    "summary": "Summary",
    "orderedWords": "Ordered Words",
    "wordsWritten": "Written Words",
    "textsDelivered": "Texts Delivered",
    "draftingInProgress": "Drafting in progress",
    "briefAwaitingValidation": "Brief awaiting validation",
    "completion": "Completed",
    "on_track": "On Track",
    "delay": "Behind schedule",
    "onDelayExplicationsFirstPart": "{percentageOfDelay} of delay.",
    "onDelayExplications": "{percentageOfDelay} of delay. To this day we should be at at least {theoreticalAdvancement} of budget delivered on the campaign. {theoreticalBudgetToSpend} of budget must be delivered to achieve this objective",
    "onTrackExplications": "To this day we should be at at least {theoreticalAdvancement} of budget delivered on the campaign.",
    "budget_delivred": "% OF BUDGET DELIVERED",
    "budget_in_process": "% OF BUDGET IN PROCESS",
    "budget_remaining": "% OF BUDGET REMAINING",
    "youStillHave": "You still have",
    "projectStatus": "Projet status",
    "explanations": "Explanation: ",
    "terminated": "Terminated"
  },
  "fr": {
    "deliveredBudget": "soit {value} du budget total",
    "totalClientBudget": "soit {clientPendingBudget} du budget total",
    "numberOfWrittenWordsAndDeliveredContents": "{numberOfWrittenWords} mots rédigés ({numberOfDeliveredContents} contenu(s))",
    "smartkeywordBudgetStats": "{smartkeywordPendingBudget} du budget total",
    "remaingingBudgetStatsRemainingBudget": "soit {remainingBudget} du budget total",
    "textToPublish": "texte(s) à publier",
    "inYourWebsite": "sur votre site",
    "at": "chez",
    "correspondTo": "Correspond à :",
    "briefsToValidate": "brief(s) à valider",
    "textsToValidate": "texte(s) à valider",
    "briefsToWrite": "brief(s) à écrire",
    "textsToWrite": "texte(s) à écrire",
    "textsToReview": "texte(s) à relire",
    "briefsToReadOver": "briefs(s) à relire",
    "textsBeingModified": "texte(s) en cours de modification",
    "textsInWriting": "texte(s) en cours de rédaction",
    "textsToModify": "texte(s) à modifier",
    "atSmartkeyword": "CHEZ SMARTKEYWORD",
    "summary": "Résumé",
    "orderedWords": "Nombre de mots commandés",
    "wordsWritten": "Nombre de mots rédigés",
    "textsDelivered": "Nombre de textes livrés",
    "draftingInProgress": "Rédaction en cours",
    "briefAwaitingValidation": "Brief en attente de validation",
    "completion": "% de Completion",
    "on_track": "On track",
    "delay": "En retard",
    "onDelayExplicationsFirstPart": "{percentageOfDelay} de retard.",
    "onDelayExplications": "À ce jour nous devrions avoir au moins {theoreticalAdvancement} de budget livré sur la campagne. {theoreticalBudgetToSpend} de budget doivent être livrés pour atteindre cet objectif.",
    "onTrackExplications": "À ce jour nous devrions avoir au moins {theoreticalAdvancement} de budget livré sur la campagne.",
    "budget_delivred": "% DE BUDGET LIVRÉ",
    "budget_in_process": "% DE BUDGET EN COURS DE TRAITEMENT",
    "budget_remaining": "% DE BUDGET RESTANT",
    "youStillHave": "Vous avez encore",
    "projectStatus": "Statut du projet",
    "explanations": "Explication :",
    "terminated": "Terminé"
  },
  "de": {
    "deliveredBudget": "Lassen Sie {Wert} des Gesamtbudgets",
    "totalClientBudget": "sei {clientPendingBudget} das Gesamtbudget",
    "numberOfWrittenWordsAndDeliveredContents": "{numberOfWrittenWords} geschriebene Wörter ({numberOfDeliveredContents} Inhalt(e))",
    "smartkeywordBudgetStats": "{smartkeywordPendingBudget} Ihr Gesamtbudget",
    "remaingingBudgetStatsRemainingBudget": "soit {remainingBudget} Ihr Gesamtbudget",
    "textToPublish": "zu veröffentlichende Texte",
    "inYourWebsite": "Auf deiner Webseite",
    "at": "im Haus von",
    "correspondTo": "Entspricht:",
    "briefsToValidate": "zu validierende Schriftsätze",
    "textsToValidate": "zu validierende(r) Text(e).",
    "briefsToWrite": "Schriftsatz(e) zu schreiben",
    "textsToWrite": "Text(e) zu schreiben",
    "textsToReview": "Text(e) zum Korrekturlesen",
    "briefsToReadOver": "Schriftsatz(e) zum Lesen",
    "textsBeingModified": "Texte, die bearbeitet werden",
    "textsInWriting": "Texte, die geschrieben werden",
    "textsToModify": "Text(e) zu ändern",
    "atSmartkeyword": "CHEZ SMARTKEYWORD",
    "summary": "Fortsetzen",
    "orderedWords": "Anzahl der bestellten Wörter",
    "wordsWritten": "Anzahl der geschriebenen Wörter",
    "textsDelivered": "Anzahl der zugestellten Texte",
    "draftingInProgress": "Ausarbeitung läuft",
    "briefAwaitingValidation": "Kurz wartet auf Validierung",
    "completion": "% Fertigstellung",
    "on_track": "Auf der Strecke",
    "delay": "in Verzug",
    "onDelayExplicationsFirstPart": "{percentageOfDelay} verzögert.",
    "onDelayExplications": "Inzwischen sollten wir mindestens {theoreticalAdvancement} Budget für die Kampagne bereitgestellt haben. {theoreticalBudgetToSpend} des Budgets muss bereitgestellt werden, um dieses Ziel zu erreichen.",
    "onTrackExplications": "Inzwischen sollten wir mindestens {theoreticalAdvancement} Budget für die Kampagne bereitgestellt haben.",
    "budget_delivred": "% DES BUDGETS GELIEFERT",
    "budget_in_process": "% DES BUDGETS IN BEARBEITUNG",
    "budget_remaining": "% VERBLEIBENDES BUDGET",
    "youStillHave": "Sie haben immer noch",
    "projectStatus": "Projekt-Status",
    "explanations": "Erläuterung :",
    "terminated": "Beendet"
  }
}
</i18n>
